import React from 'react';
import { MnLoading } from '../../../index';
import { Layout } from '../organisms/index';
import SimpleFormat from '@16g/react-simple-format';
import ReactMarkdown from 'react-markdown/with-html';

export default class TermShow extends React.Component {
  text = `
### 第1条（適用）
- 本規約は、本サービス提供条件および本サービスの利用に関する株式会社メディカルノート（以下、「当社」という。）とユーザーとの間の権利義務関係を定めることを目的とし、ユーザーと当社との間の本サービスの利用に関わる一切の関係に適用される。
- 本規約の内容と、本規約外における本サービスの説明等（以下、「個別規定」という。）とが異なる場合は、個別規定が優先して適用されるものとする。
- ユーザーが未成年である場合には、親権者等の法定代理人の同意（本規約への同意を含む。）を得て本サービスを利用するものとし、また、本規約に同意した時点で未成年であったユーザーが、成年に達した後に本サービスを利用した場合、未成年であった間の利用行為を追認したものとみなす。
### 第2条（定義）
- 「本サービス」とは、当社が企画・運営する「MedicalNote治療支援サービス」（理由の如何を問わずサービスの名称または内容が変更された場合は、当該変更後のサービスを含む。）をいう。
- 「ユーザー」とは、本サービスを利用して契約医療機関による診療等を受ける個人をいう。
- 「本サービス提供ページ」とは、当社が本サービスを提供するためのウェブページをいう。
- 「本契約」とは、当社がユーザーに対し、本規約に基づき本サービスを提供し、ユーザーが当社、契約医療機関及び決済代行会社に対し、本規約に基づき発生する料金を支払うことを約することをいう。
- 「契約医療機関」とは、当社とサービス利用契約を締結した医療機関その他の法人であり、診療等に従事する者をいう。
### 第3条（ユーザー）
- ユーザーは、本サービスの利用に際し、本規約の定めに従うことを承諾したものとみなす。
- ユーザーは、自らの意思によって本サービスを利用するものとする。
- ユーザーが、本サービスを通じて診療申込みを完了することにより、本契約が成立するものとする。
- 当社は、ユーザーが以下に定める事由のいずれかに該当すると判断した場合、本サービスの利用を拒否することができるものとする。なお、当社は、当該サービス利用拒否について一切の責任を負わず、拒否の理由を説明する義務を負わない。
  - 本規約に違反する行為を行うおそれがある場合または過去に違反した事実が判明した場合
  - 本サービスの利用にあたり当社に提供された情報に虚偽の記載や記載漏れがあった場合
  - その他当社が不適切と判断した場合
- ユーザーは、本サービスの利用にあたり、本サービス提供ページ上に入力した情報の内容について一切の責任を負う。また、ユーザーは本サービス上で自ら作成・保存したデータおよび契約医療機関が本サービスを経由してユーザーに提供したデータ（以下、「ユーザーデータ」という。）の保管およびバックアップについては自ら責任を負うものとする。
- ユーザーは、自らの責任と費用において、本サービスの利用に必要な環境（ハードウェア、ソフトウェア、インターネット接続回線、セキュリティーの確保等）を整備するものとする。当社は、ユーザーデータの情報セキュリティーを確保するために、本サービスに関するインフラストラクチャ、ネットワーク、アプリケーション及びデータ等を対象とした情報セキュリティー対策を行うこととする。
### 第４条（予約・診療等）
- ユーザーは、本サービス提供ページを通じて、契約医療機関に対し、診療等の予約をすることができる。
- ユーザーは、診療等の予約にあたり、本サービス提供ページ上に必要な情報を入力するものとする。
- ユーザーは、診療メニューに応じ、契約医療機関において対面での診察を受けた後又は契約医療機関が第１項の予約を応諾した後でなければ本サービス提供ページを通じたオンラインによる診療等を受けられない場合があることに同意するものとする。
- ユーザーは、ユーザーが本サービス提供ページを通じて契約医療機関に対し診療等の予約をした場合、本サービスの利用にあたりユーザーが入力した情報が、当該医療機関に共有されることについて同意するものとする。
- ユーザーが第1項に従って診療等の予約をし、前項に基づき契約医療機関に対してユーザーの入力情報が通知された時点で、ユーザーと当該契約医療機関との間で本サービス提供ページ記載の内容にしたがって診療等に関する契約が締結されるものとする。ただし、契約医療機関が当該予約を応諾しない場合は、この限りではない。
- ユーザーに対する診察・検査・処置等、処方せんの発行または医薬品の配送は、前項の契約に基づき契約医療機関所属の医師等またはそのスタッフがその責任と費用をもって行い、当社はこれらの行為についていかなる責任も負わないものとする。
- 診療等に関する契約に関連して生じた問い合わせ、苦情、請求、紛争等については、ユーザーと契約医療機関及び所属医師等との間で解決するものとする。当社は、これらの紛争等について一切責任を負うことなく、また、その解決に関与する義務を負わないものとする。
### 第５条（診療費用）
- 当社は、本サービス提供ページ上で、診療メニューに応じ、契約医療機関が設定する診療等の費用の見込み金額を示すものとする。契約医療機関所属の医師等による診療等が保険診療の場合にあっては、当該費用の表示はユーザーの一部負担金（健康保険法74条1項に規定するものをいう。）の見込み金額を示すものとする。
- ユーザーは、契約医療機関所属の医師等の診療内容により、実際の診療等の費用が、前項に従い本サービス提供ページ上に表示された金額を上回ることや下回ることがあることに同意する。
- ユーザーは、診療等の実施後、確定した診療等の費用又は一部負担金について、また、予約が成立したにもかかわらずユーザーの都合で診療等が実施できなかった場合には、契約医療機関に支払われる予約料について、それぞれ当社に支払われる本サービス利用料及び決済代行会社に支払われる手数料とともに、決済代行会社を通じて支払う義務を負う。なお、当社は診療等の費用の支払いには一切関与せず、また責任を負わない。
- 前項の費用の支払いは、ユーザーがサービス提供ページ上で番号等を入力したクレジットカードによってなされるものとする。
- 保険診療につき、ユーザーが本サービス提供ページを通じて予約を行い診療等を受けたにもかかわらず、ユーザーが提示する健康保険証が失効等していた場合には、ユーザーは診療費用全額から支払済の一部負担金を差し引いた金員についても支払義務を負う。
- ユーザーは、ユーザーが予約した日時に限り、本サービス提供ページを通じた契約医療機関所属の医師等によるオンラインでの診療等を受診することができる。ユーザーは、予約した時間内に契約医療機関所属の医師等によるオンラインでの診療等が完了しなかった場合でも、その時間内に受けた診療内容に応じて診療等の費用の支払義務を負うことに同意するものとする。
### 第６条（禁止事項・損害賠償）
- ユーザーは、以下の各行為を行ってはならない。
  - 当社、契約医療機関及び所属医師等に対し虚偽の情報を提供する行為
  - 他人の診療を受ける目的で本サービスを利用する行為
  - 本サービスの利用に関し、自らまたは第三者のために不正な利益を得ようとする行為
  - 他人の知的財産権、プライバシーに関する権利、その他の権利または利益を侵害する行為
  - コンピューター・ウイルスその他の有害なコンピューター・プログラムを含む情報を送信する行為
  - 個人や団体を誹謗中傷する行為
  - 本サービスで得た情報を本サービスの利用目的の範囲を超えて第三者に譲渡・公開する行為または営利目的で譲渡・公開する行為
  - 公序良俗に反する行為
  - 法令に反する一切の行為
  - 本サービスの運営を妨げる行為
  - その他本サービスの提供を継続することが困難であると当社が判断する一切の行為
- ユーザーが本規約の各条項に違反し、当社または第三者に対して損害を与えた場合は、ユーザーは当社または第三者に対し損害賠償義務を負うものとする。
### 第７条（情報の変更・削除、本契約の解除等）
- 当社は、ユーザーが本規約に違反する行為をし、もしくはその行為をする恐れがある場合、ユーザーによる本サービスの利用が不適切であると当社が判断する場合、ユーザーによる本サービスの利用により本サービスの運営に支障が生じると当社が判断する場合、当該ユーザーに何ら事前の通知をすることなく次の各号に掲げる措置を講じることができる。なお、当社はユーザーに対し、これらの措置を講じる理由について説明する義務を負わない。
  - ユーザーが本サービスにおいて入力した情報の全部または一部についての変更または削除
  - 本契約の解除およびそれに伴う本サービス利用の停止
  - その他当社が必要と認める措置
### 第８条（サービス内容の変更）
- 当社は、ユーザーの事前の承諾なしに本サービスの内容を変更することができる。
### 第９条（サービス停止・終了等）
- 当社は、次の各号のいずれかに該当する事由によりユーザーへの事前の通知および承諾を要することなく、本サービスを停止または終了することができる。
  - 本サービス運営のためのシステムの保守、更新等を定期的または臨時に行う場合
  - ウィルス被害、火災、停電、天災地変などの不可抗力により、本サービスの提供が困難な場合
  - 第三者の故意または過失による行為によって発生した本システムの不具合について対策を講じる必要がある場合
  - 法令等の改正、成立により本サービスの運営が困難となった場合
  - その他、当社が本サービスの提供の停止・終了が必要と判断した場合
### 第10条（免責）
- 当社は、ユーザーによる本サービスの利用に関し、契約医療機関等の第三者が提供する情報等の正確性、有用性、完全性等について何らの保証をしない。
- 当社は、ユーザーによる本サービスの利用に関し、次の各号に掲げることを保証しない。
  - 本サービスが中断しないこと
  - 本サービスにエラーが生じないこと
  - 本サービスの利用に関し通信回線等の障害がないこと
  - 本サービス提供ページに対する不正アクセス・ハッキング等のサイバー攻撃がないこと
- 当社は、ユーザーの本サービスの利用から生じる一切の損害に関して、責任を負わない。
- 当社は、当社によるユーザー情報の変更、削除または消失、本サービスの内容の変更、本サービスの提供の停止または終了、本サービスの利用不能、本サービスの利用によるデータの消失または機器の故障若しくは損傷、その他本サービスに関連してユーザーが被った損害につき、一切責任を負わない。
- 前3条の規定により、ユーザーの情報が変更・削除された場合、本契約が解除された場合、本サービス内容が変更された場合、または本サービスが停止・終了した場合においても、ユーザーと契約医療機関との間で成立する診療等に関する契約の内容に影響を及ぼすものではない。
- 当社は、ユーザーによる本サービスの利用により、ユーザーの疾病・疾患が治癒し、診療等が終了することを保証するものではなく、また、契約医療機関がユーザーの診療等を開始・継続することを保証するものではない。
- 当社が本サービスに関してユーザーに対して損害賠償責任を負うべき場合でも、ユーザーは当社に損害発生についての故意または重過失がある場合に限り損害賠償を請求することができる。この場合において、当社の責任は直接損害に限られるものとする。
### 第11条（暴力団等の排除）
- ユーザーは、現在、暴力団、暴力団員、暴力団員でなくなった時から5年を経過しない者、暴力団準構成員、暴力団関係企業、総会屋等、社会運動等標ぼうゴロまたは特殊知能暴力団等、その他これらに準ずる者(以下、これらを「暴力団員等」という。)に該当しないことを表明し、かつ将来にわたっても該当しないことを確約する。
- ユーザーは、自らまたは第三者を利用して次の各号の一に該当する行為を行わないことを確約する。
  - 暴力的な要求行為
  - 法的な責任を超えた不当な要求行為
  - 取引に関して、脅迫的な言動をし、または暴力を用いる行為
  - 風説を流布し、偽計を用いまたは威力を用いて、当社、他の利用者、その他第三者の信用を毀損し、または、当社、他の利用者、その他第三者の業務を妨害する行為
  - その他前各号に準ずる行為
- 当社は、ユーザーが前二項に違反した場合には、通知、催告その他の手続を要しないで、直ちに本契約を解除し、本サービスの利用を停止することができるものとする。
### 第12条（提供情報の利用）
- 本サービスにおける個人情報の取り扱いについては、当社の定めるプライバシーポリシーに従うものとする。ユーザーは、本サービスを利用する場合には、プライバシーポリシーの各規定に従うことを承諾したものとみなす。
- 当社は、本サービスを提供する上でユーザーにとって必要な情報を、ユーザーに対し、Eメール、郵便、電話、対面での伝達等によって連絡をすることができるものとする。
- 当社は、当社の定めるプライバシーポリシーで定義される個人情報を含まない限りにおいて、入力された情報または本サービスの利用状況についての情報を、あらゆるものに二次利用することができるものとする。これらの情報に関わる知的財産権は当社が保有するものとする。
- ユーザーは、本サービスの利用に伴い発生する各種ログ情報を含むユーザーデータを、本サービスの提供する機能を通じてのみ閲覧・利用できるものとし、当社はログその他のユーザーデータの提供依頼等に対応する義務を負わないものとする。
### 第13条（規約の変更）
- 当社は、本規約を随時変更することができる。なお当社は、本規約を変更する場合、当社のウェブサイトにて本規約を変更する旨及び変更後の本規約の内容並びにその効力発生時期を告知する。
### 第14条（地位譲渡）
- ユーザーは、当社の書面による事前の承諾なく、本規約に基づく権利または義務につき、第三者に対し、譲渡、移転、担保設定、その他の処分をすることや、第三者に相続させることはできない。
- 当社が本サービスにかかる事業を第三者に譲渡する場合には、ユーザーの承諾を得ることなく、当該事業譲渡に伴い、本規約に基づく権利および義務並びにユーザーの入力した情報その他の顧客情報等を含む本契約上の地位を当該事業譲渡の譲受人に譲渡することができる。なお、このことは、事業譲渡のみならず、会社分割その他事業が移転するあらゆる場合においても同様とする。
### 第15条（準拠法および管轄裁判所）
- 本サービスおよび本規約を含む本契約の準拠法は日本法とする。本サービスおよび本規約を含む本契約に関して生じる一切の紛争については、東京地方裁判所または東京簡易裁判所を第 1 審の専属的合意管轄裁判所とする。
`;

  render () {
    return (<React.Suspense fallback={ <MnLoading/> }>
      <Layout state={this.props}>
        <div className="p-container p-menus">
          <div className="l-conatiner">
            <h4 className="w90p c-mn-title-2 ta-c">MedicalNote<br/>治療支援サービス<br/>利用規約</h4>
            <div className="p-container--content p-container--md">
              <ReactMarkdown source={this.text} escapeHtml={true}/>
            </div>
            <div className="p-container--card ta-c">
              <SimpleFormat text="2020年10月1日制定"/>
            </div>
          </div>
        </div>
      </Layout>
    </React.Suspense>);
  }
}
